/*
 * Copyright (c) 2022-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';
import PropTypes from 'prop-types';
import DisplayIcon from "../Icons/DisplayIcon.jsx";
import {motion} from "motion/react";
import Tooltip from "../Tooltip.jsx";


/*
 * This Component Displays a Button with an icon
 * @example    <ButtonComponent text={"Add new"} activeColor={"bg-green-50"} iconHoverColor={"text-green-500"} />
 */
class IconButtonComponent extends React.PureComponent {
    constructor() {
        super();

        this.state = {
            isLoading: false
        }
    }


    render() {
        let {size = "normal", isLoading, id, iconNameClassName} = this.props

        let sizeClassName = "h-4 w-4"
        let buttonClassName = "p-2"
        switch (size) {
            case "sm":
                sizeClassName = "h-3 w-3"
                buttonClassName = "p-1.5"
                break
            case "md":
                sizeClassName = "h-3.5 w-3.5"
                buttonClassName = "p-1"
                break
            case "normal":
                sizeClassName = "h-4 w-4"
                buttonClassName = "p-2"
                break
            case "large":
                sizeClassName = "h-5 w-5"
                buttonClassName = "p-2"
                break
            case "xl":
                sizeClassName = "h-6 w-6"
                buttonClassName = "p-3"
                break
        }


        return (
            <Tooltip text={this.props.text} delay={1000}>
                <motion.button type="button" whileTap={{scale: 0.9}}
                               id={id}
                               className={`${buttonClassName} focus:ring-blue-300 text-sm group select-none hover:bg-stone-50 focus:outline-none rounded-md text-blue-400 bg-white  transition duration-200 items-center ease-in-out active:${this.props.activeColor} ${this.props.className} focus-visible:bg-blue-50 focus-visible:ring-1`}
                               onClick={async (event) => {
                                   event.preventDefault()
                                   event.stopPropagation()
                                   this.setState({isLoading: true})
                                   if (this.props.onClick !== undefined) {
                                       await this.props.onClick(event)
                                   }
                                   this.setState({isLoading: false})
                               }}>
                    {(this.state.isLoading || isLoading) ? (
                        <DisplayIcon
                            iconName={"Spinner"}
                            className={`${sizeClassName} animate-spin shrink-0 will-change-transform`}/>) : (
                        <DisplayIcon iconName={this.props.iconName}
                                     className={`${sizeClassName} ${iconNameClassName} group-hover:${this.props.iconHoverColor}`}/>)}
                </motion.button>

            </Tooltip>
        )
    };
}

export default IconButtonComponent;

IconButtonComponent.propTypes = {
    /**
     * The text of the Button
     */
    text: PropTypes.string.isRequired,
    /**
     * The event if the button is pressed
     * @example (value)=>{console.log(value)}
     */
    onClick: PropTypes.func,
    /**
     * The hover color of the icon
     * @example text-green-500
     * @default text-gray-100
     */
    iconHoverColor: PropTypes.string,
    /**
     * The color if the button is pressed
     *  @example bg-green-50
     *  @default bg-gray-100
     */
    activeColor: PropTypes.string,
    /**
     * The color if the button is pressed
     *  @example IoIosAdd
     *  @default IoIosAdd
     */
    iconName: PropTypes.string,
    className: PropTypes.string,
    size: PropTypes.string,


}

IconButtonComponent.defaultProps = {
    text: '',
    iconHoverColor: 'text-gray-300',
    activeColor: 'bg-gray-100',
    iconName: 'IoIosAdd'
}